/* Dark ticker under the orange header, a three-line benefit list after the
   price, a real customer photo band above the reviews, and copy trims.
   Delivery window is the real one: 6–10 business days. */
(function(){
var LIFESTYLE='https://cdn.shopify.com/s/files/1/0979/3604/8475/files/if-lifestyle-1.webp?v=1789994285';
var done=false;

function el(t,s,h){var e=document.createElement(t);if(s)e.setAttribute('style',s);if(h!==undefined)e.innerHTML=h;return e;}

/* The dark section ran long enough that people stopped reading it.
   Same claims, roughly half the words. */
var TRIMS=[
[/Most gag gifts get one laugh[\s\S]*under a helmet\./,'Most gag gifts get one laugh and live in a drawer. This one gets worn all week \u2014 a thin stretch knit that seals the neck and vanishes under a helmet.'],
[/No bulk at the crown[\s\S]*over the top\./,'No bulk at the crown. Goggles sit right over the top.'],
[/Full-face coverage that seals the neck gap[\s\S]*12\u00b0C\./,'Seals the neck gap. Good to \u221212\u00b0C.'],
[/Dyed into the fabric, not screened on[\s\S]*without fading\./,'Dyed into the fabric. Washes without fading.'],
[/Stretches 21[\s\S]*Unisex\./,'Stretches 21\u201324\u2033. Unisex.']
];

function trimCopy(root){
try{
var nodes=root.querySelectorAll('p,div,span,li');
for(var i=0;i<nodes.length;i++){
var n=nodes[i];
if(n.children.length)continue;
var t=n.textContent;
if(!t)continue;
for(var k=0;k<TRIMS.length;k++){
if(TRIMS[k][0].test(t)){n.textContent=t.replace(TRIMS[k][0],TRIMS[k][1]);break;}
}
if(/Arrives in \d+/.test(n.textContent)){n.textContent=n.textContent.replace(/Arrives in \d+\s*[\u2013-]\s*\d+( business)? days/,'Arrives in 6\u201310 business days');}
else if(/Ships in 1\s*[\u2013-]\s*2/.test(n.textContent)){n.textContent='Ships in 1\u20132 business days';}
}
}catch(e){}
}

function build(){
if(done)return true;
var root=document.getElementById('if');
var tag=document.getElementById('if-tag');
if(!root||!tag)return false;
var priceRow=tag.nextElementSibling;
if(!priceRow)return false;
done=true;

var hdr=root.querySelector('header');
if(hdr&&!document.getElementById('if-marquee')){
var ks=document.createElement('style');
ks.textContent='@keyframes ifmarquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}';
document.head.appendChild(ks);
var bar=document.createElement('div');
bar.id='if-marquee';
bar.setAttribute('style','background:#12161C; overflow:hidden; white-space:nowrap; padding:8px 0;');
var run='FITS UNDER ANY HELMET &nbsp;&bull;&nbsp; WARM TO &minus;12&deg;C &nbsp;&bull;&nbsp; PRINT NEVER CRACKS &nbsp;&bull;&nbsp; 30-DAY RETURNS &nbsp;&bull;&nbsp; ';
bar.innerHTML='<div style="display:inline-block; animation: ifmarquee 26s linear infinite;"><span style="font-family: Bebas Neue, sans-serif; color:#fff; font-size:15px; letter-spacing:1.5px;">'+run+run+'</span></div>';
hdr.parentNode.insertBefore(bar,hdr.nextSibling);
}

if(!document.getElementById('if-benefits')){
var items=[
['\uD83C\uDFBF','Disappears under any helmet, goggles straight over the top'],
['\uD83E\uDD76','Seals the neck gap. Warm down to &minus;12&deg;C'],
['\uD83C\uDF81','The gag gift they actually wear all week']
];
var wrap=document.createElement('ul');
wrap.id='if-benefits';
wrap.setAttribute('style','list-style:none; margin:0 0 16px; padding:0; display:flex; flex-direction:column; gap:6px;');
items.forEach(function(it){
var li=document.createElement('li');
li.setAttribute('style','display:flex; align-items:flex-start; gap:9px; font-size:13.5px; line-height:1.4; color:#3F4954;');
li.innerHTML='<span style="font-size:15px; line-height:1.3; flex-shrink:0;">'+it[0]+'</span><span>'+it[1]+'</span>';
wrap.appendChild(li);
});
priceRow.parentNode.insertBefore(wrap,priceRow.nextSibling);
}

var reviews=document.getElementById('reviews');
if(reviews&&!document.getElementById('if-lifestyle')){
var band=el('section','position:relative; margin:0; padding:0; background:#12161C; overflow:hidden;');
band.id='if-lifestyle';
band.innerHTML=
'<img src="'+LIFESTYLE+'" alt="Skiers laughing at a friend wearing the Old Man Winter ski mask" loading="lazy" style="width:100%; height:min(62vh,520px); object-fit:cover; object-position:50% 28%; display:block;">'+
'<div style="position:absolute; inset:0; background:linear-gradient(180deg, rgba(18,22,28,0) 45%, rgba(18,22,28,0.88));"></div>'+
'<div style="position:absolute; left:0; right:0; bottom:0; padding: clamp(18px,4vw,34px) clamp(16px,4vw,28px); text-align:center;">'+
'<div style="font-family: Bebas Neue, sans-serif; color:#fff; font-size:clamp(24px,5.5vw,38px); letter-spacing:0.8px; line-height:1.02; margin-bottom:6px;">NOBODY LOOKS AT THE SLOPE ANYMORE</div>'+
'<div style="color:#C3CBD3; font-size:clamp(13.5px,3vw,16px); line-height:1.5; max-width:520px; margin:0 auto;">Put it on at the first lift. Spend the rest of the day being the reason strangers are laughing.</div>'+
'</div>';
reviews.parentNode.insertBefore(band,reviews);
}

trimCopy(root);
return true;
}

var n=0;
var iv=setInterval(function(){n++;if(build()||n>60)clearInterval(iv);},80);
if(document.readyState!=='loading')build();else document.addEventListener('DOMContentLoaded',build);
})();
